<template>
  <collection-grid-b v-bind="$props"></collection-grid-b>
</template>

<script>
import CollectionGridB from './CollectionGridB.vue'

export default {
  name: 'CollectionGrid',
  components: { CollectionGridB },
  props: {
    wishlistEnabled: Boolean,
    handle: String,
    initCollectionData: Object,
    initCollectionTotal: Number,
    initCollectionProducts: Array,
    totalProducts: Number,
    paginationAmount: Number,
    tags: Array,
    filters: Array,
    collectionGender: String,
    visibilitySettings: {
      type: Object,
      default: () => ({
        filtersDisabled: Number
      })
    }
  }
}
</script>
